import { render, staticRenderFns } from "./RelationDetailsSkeleton.vue?vue&type=template&id=10f9f5e6&scoped=true"
import script from "./RelationDetailsSkeleton.vue?vue&type=script&lang=ts"
export * from "./RelationDetailsSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9f5e6",
  null
  
)

export default component.exports